module.exports = __webpack_public_path__ + "static/img/aizixun.caf873a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/aizixun.png
// module id = d1gW
// module chunks = 1